import React from "react";
import "./SkeletonLoader.css";

const SkeletonLoader = ({ rows = 5 }) => {
  return (
    <div className="skeleton-table">
      <div className="skeleton-header">
        <div className="skeleton-line w-25" />
        <div className="skeleton-line w-16" />
        <div className="skeleton-line w-16" />
        <div className="skeleton-line w-16" />
        <div className="skeleton-line w-16" />
      </div>

      {[...Array(rows)].map((_, i) => (
        <div className="skeleton-row" key={i}>
          <div className="skeleton-line w-25" />
          <div className="skeleton-line w-16" />
          <div className="skeleton-line w-16" />
          <div className="skeleton-line w-16" />
          <div className="skeleton-line w-16" />
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
